if (!customElements.get("slideshow-component")) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super()
      this.selectors = {
        contents: ['.f-slideshow__content-wrapper'],
        selected: '.selected',
        flickity: 'flickity-component',
        pageDots: '.flickity-page-dots',
        pageCounter: '.flickity-page-counter'
      }
      this.domNodes = queryDomNodes(this.selectors, this)
      this.prevIndex = 0
      this.countdownIntervals = []
      this.init()
      this.initCountdowns()
    }
    
    disconnectedCallback() {
      clearInterval(this.check)
      this.countdownIntervals.forEach(id => clearInterval(id))
      this.countdownIntervals = []
    }

    init() {
      this.check = setInterval(() => {
        this.slider = this.domNodes.flickity.slider && this.domNodes.flickity.slider.instance
        if (this.slider && typeof this.slider == 'object') {
          clearInterval(this.check)
          this.removeAttribute('data-media-loading')
          this.slider.on('change', this.handleChange.bind(this))
          this.domNodes.contents[0].classList.add('selected')
          this.handleScreenChange()
          this.playVideo()
          if (this.domNodes.pageCounter) {
            this.domNodes.flickity.insertBefore(this.domNodes.pageCounter, null)
          }
        }
      }, 100)
    }

    handleChange(index) {
      const sliderCounterCurrent = this.querySelector('.flickity-counter--current')
      const slideContentCurrent = this.domNodes.contents[index];
      const currentTextColor = slideContentCurrent.dataset.textColor;
      this.style.setProperty('--slider-controls-color', currentTextColor);

      this.domNodes.contents.forEach(item => item.classList.remove('selected'))
      this.domNodes.contents[this.prevIndex].classList.add('f-slideshow__content--out')
      this.domNodes.contents[index].classList.add('selected')
      setTimeout(() => {
        this.domNodes.contents[this.prevIndex].classList.remove('f-slideshow__content--out')
        this.prevIndex = index
      }, 300)

      // Handle page counter
      if (this.domNodes.pageCounter && sliderCounterCurrent) {
        sliderCounterCurrent.textContent = index + 1
      }
      
      this.playVideo()
    }

    playVideo() {
      this.pauseAllMedia()
      const selectedElm = this.slider.selectedElement
      const deferredMedia = selectedElm.querySelector('deferred-media')
      if (deferredMedia) {
        deferredMedia.loadContent()
        const youtube = deferredMedia.querySelector('.js-youtube')
        const vimeo = deferredMedia.querySelector('.js-vimeo')
        const video = deferredMedia.querySelector('video')
        if (video) video.play()
        if (youtube) youtube.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*')
        if (vimeo) vimeo.contentWindow.postMessage('{"method":"play"}', '*')
      }
    }

    pauseAllMedia() {
      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.pause());
    }

    handleScreenChange() {
      if (FoxThemeSettings.isMobile) {
        // this.domNodes.flickity.toggleFade()
      }
      document.addEventListener('matchMobile', () => {
        // this.domNodes.flickity.toggleFade()
      })
      document.addEventListener('unmatchMobile', () => {
        // this.domNodes.flickity.toggleFade(true)
      })
    }

    initCountdowns() {
      const countdowns = this.querySelectorAll('.f-slideshow__countdown')
      countdowns.forEach(countdown => {
        const targetStr = countdown.dataset.countdownTarget
        if (!targetStr) return
        const targetDate = new Date(targetStr).getTime()
        if (isNaN(targetDate)) return

        const daysEl = countdown.querySelector('[data-countdown-days]')
        const hoursEl = countdown.querySelector('[data-countdown-hours]')
        const minutesEl = countdown.querySelector('[data-countdown-minutes]')
        const secondsEl = countdown.querySelector('[data-countdown-seconds]')
        const hideOnExpire = countdown.dataset.countdownHide === 'true'

        const updateCountdown = () => {
          const nowInMadrid = new Date(new Date().toLocaleString('en-US', {timeZone: 'Europe/Madrid'}))
          const distance = targetDate - nowInMadrid.getTime()

          if (distance <= 0) {
            this.updateDigits(daysEl, '00')
            this.updateDigits(hoursEl, '00')
            this.updateDigits(minutesEl, '00')
            this.updateDigits(secondsEl, '00')
            if (hideOnExpire) {
              countdown.classList.add('f-slideshow__countdown--expired')
            }
            const idx = this.countdownIntervals.indexOf(intervalId)
            if (idx > -1) {
              clearInterval(intervalId)
              this.countdownIntervals.splice(idx, 1)
            }
            return
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24))
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
          const seconds = Math.floor((distance % (1000 * 60)) / 1000)

          this.updateDigits(daysEl, String(days).padStart(2, '0'))
          this.updateDigits(hoursEl, String(hours).padStart(2, '0'))
          this.updateDigits(minutesEl, String(minutes).padStart(2, '0'))
          this.updateDigits(secondsEl, String(seconds).padStart(2, '0'))
        }

        updateCountdown()
        const intervalId = setInterval(updateCountdown, 1000)
        this.countdownIntervals.push(intervalId)
      })
    }

    updateDigits(container, value) {
      if (!container) return
      const digits = container.querySelectorAll('.countdown-digit')
      const chars = value.split('')

      // Ensure we have the right number of digit spans
      while (digits.length < chars.length) {
        const span = document.createElement('span')
        span.className = 'countdown-digit'
        span.textContent = '0'
        container.appendChild(span)
      }

      const currentDigits = container.querySelectorAll('.countdown-digit')
      chars.forEach((char, i) => {
        if (i < currentDigits.length && currentDigits[i].textContent !== char) {
          const digit = currentDigits[i]
          digit.classList.remove('flip-in')
          digit.classList.add('flip-out')
          setTimeout(() => {
            digit.textContent = char
            digit.classList.remove('flip-out')
            digit.classList.add('flip-in')
            setTimeout(() => {
              digit.classList.remove('flip-in')
            }, 300)
          }, 300)
        }
      })
    }
  }

  customElements.define('slideshow-component', SlideshowComponent)
}